import { Enrollment, EnrollmentDto } from './Enrollment';
import { PaymentStatus } from 'models/payments/PaymentStatus';
import { utilities } from 'utils/utilities';

export interface SecurityDepositEnrollmentDto extends EnrollmentDto {
  customerPaymentId?: string;
  amountMinorUnits: number;
  currency: string;
  localPaymentStatus: PaymentStatus;
  description?: string;
  isAwaitingTeamInput?: boolean;
}

export class SecurityDepositEnrollment extends Enrollment {
  readonly type = 'SecurityDepositEnrollment';

  customerPaymentId?: string;
  amountMinorUnits: number;
  currency: string;
  localPaymentStatus: PaymentStatus;
  description?: string;
  isAwaitingTeamInput: boolean = false;

  constructor(
    id: string,
    amountMinorUnits: number = 0,
    currency: string = 'usd',
    localPaymentStatus: PaymentStatus = PaymentStatus.Pending,
    customerPaymentId?: string,
    description?: string,
    isAwaitingTeamInput: boolean = false,
  ) {
    super(id);
    this.amountMinorUnits = amountMinorUnits;
    this.currency = currency;
    this.localPaymentStatus = localPaymentStatus;
    this.customerPaymentId = customerPaymentId;
    this.description = description;
    this.isAwaitingTeamInput = isAwaitingTeamInput;
  }

  toDto(): SecurityDepositEnrollmentDto {
    return {
      id: this.id,
      enrollmentType: this.type,
      dtoType: 'Models.Api.Dtos.SecurityDepositEnrollmentDto',
      nodeInstanceId: this.nodeInstanceId,
      requiredSubmissionType: this.requiredSubmissionType,
      status: this.status,
      satisfiedAt: this.satisfiedAt,
      customerPaymentId: this.customerPaymentId,
      amountMinorUnits: this.amountMinorUnits,
      currency: this.currency,
      localPaymentStatus: this.localPaymentStatus,
      description: this.description,
      isAwaitingTeamInput: this.isAwaitingTeamInput,
    };
  }

  static fromDto(dto?: Partial<SecurityDepositEnrollmentDto> | SecurityDepositEnrollment | any): SecurityDepositEnrollment {
    if (!dto) {
      return new SecurityDepositEnrollment(utilities.DEFAULT_GUID);
    }
    if (dto instanceof SecurityDepositEnrollment) {
      return dto;
    }
    const enrollment = new SecurityDepositEnrollment(
      dto.id ?? utilities.DEFAULT_GUID,
      dto.amountMinorUnits ?? 0,
      dto.currency ?? 'usd',
      dto.localPaymentStatus ?? PaymentStatus.Pending,
      dto.customerPaymentId,
      dto.description,
      dto.isAwaitingTeamInput ?? false,
    );
    enrollment.nodeInstanceId = dto.nodeInstanceId ?? utilities.DEFAULT_GUID;
    enrollment.requiredSubmissionType = dto.requiredSubmissionType ?? '';
    if (dto.status) enrollment.status = dto.status;
    enrollment.satisfiedAt = dto.satisfiedAt;
    return enrollment;
  }
}

Enrollment.register('SecurityDepositEnrollment', (d?: any) => SecurityDepositEnrollment.fromDto(d));
Enrollment.register('Models.Enrollments.SecurityDepositEnrollment', (d?: any) => SecurityDepositEnrollment.fromDto(d));
